import Checkmark from '../assets/li_checkmark.svg';
import '../knowledge-radios.css';

type CheckboxItemProps = {
  id: string;
  checked: boolean;
  caption: string;
  disabled?: boolean;
  hasError?: boolean;
  variant?: 'default' | 'tile';
  onChange: (checked: boolean) => void;
};

function CheckboxItem({ id, checked, caption, disabled, hasError, variant = 'default', onChange }: CheckboxItemProps) {
  const handleChange = (next: boolean) => {
    if (disabled) return;
    onChange(next);
  };

  if (variant === 'tile') {
    return (
      <div className="kr-checkbox-container" data-error={hasError ? 'true' : undefined}>
        <input
          type="checkbox"
          id={id}
          name={id}
          checked={checked}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={disabled}
          aria-invalid={hasError ? true : undefined}
        />
        <label htmlFor={id} className="kr-checkbox-label">
          <span className="kr-checkbox-custom">{checked && <img src={Checkmark} alt="" className="w-3 h-3" />}</span>
          <span className="radio-text">{caption}</span>
        </label>
      </div>
    );
  }

  return (
    <label
      style={{ marginBottom: 'unset' }}
      htmlFor={id}
      className={`
        flex items-center gap-2 p-4 w-full border rounded-lg backdrop-blur-[15px]
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${
          hasError
            ? 'bg-interactive-surface-hover border-form-border-error'
            : checked
              ? 'bg-interactive-surface-focus border-interactive-outline-focus'
              : `bg-interactive-surface-hover border-interactive-outline-default ${disabled ? '' : 'hover:border-interactive-outline-hover'}`
        }
      `}
    >
      <input
        type="checkbox"
        name={id}
        id={id}
        checked={checked}
        onChange={(e) => handleChange(e.target.checked)}
        disabled={disabled}
        className="sr-only peer not-visible"
        aria-invalid={hasError ? true : undefined}
      />
      <div className="flex items-center self-stretch">
        <div className="flex items-center justify-center relative shrink-0 w-4 h-4">
          <div
            className={`
              absolute w-4 h-4 rounded transition-all
              ${
                hasError
                  ? 'bg-white border border-form-border-error'
                  : checked
                    ? 'bg-action-default border border-action-default'
                    : 'bg-white border border-form-border-default'
              }
            `}
          />
          <div
            className={`
              absolute w-4 h-4 rounded border-2 opacity-0 transition-opacity peer-focus-visible:opacity-100
              ${hasError ? 'border-form-border-error' : 'border-action-focus-border'}
            `}
          />
          {checked && <img src={Checkmark} alt="" className="relative w-4 h-4 z-10" />}
        </div>
      </div>
      <p className="flex-1 text-sm font-normal leading-5 text-content-primary">{caption}</p>
    </label>
  );
}

export default CheckboxItem;
